import React from 'react';
import { Container, Content, HiddenContent, Icon, IconContainer, InitialContainer } from './styles';
import arrow from '../../assets/icons/CircleArrow.svg';

interface IDropdown {
  onClick: React.MouseEventHandler<HTMLDivElement>;
  state: boolean;
  content: string;
  marginTop?: number;
}

export const FaqDropdown: React.FC<IDropdown> = ({children, onClick, content, state, marginTop}) => {
  return (
    <Container state={state} marginTop={marginTop} className={`${state? 'show':''}`} onClick={onClick}>
      <InitialContainer>
        <Content>{content}</Content>
        <IconContainer>
          <Icon className={`${state? 'flip':''}`} src={arrow}/>
        </IconContainer>
      </InitialContainer>
      <HiddenContent>
        {children}
      </HiddenContent>
    </Container>
  );
}
